import { SectionsState, SectionsTypes } from './types';

const INITIAL_STATE: SectionsState = {
  sectionData: {
    id: '',
    name: '',
    startId: '',
    endId: '',
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
  },
  sectionCreated: {
    id: '',
    name: '',
    startId: '',
    endId: '',
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
  },
  sectionsList: [],
  totalCount: 0,
  loading: false,
  error: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Sections
const listSectionsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  sectionsList: INITIAL_STATE.sectionsList,
});

const listSectionsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  sectionsList: action.payload.sectionsList,
  totalCount: action.payload.totalCount,
});

const listSectionsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  sectionsList: INITIAL_STATE.sectionsList,
});

// Get Section
const getSectionRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  sectionData: INITIAL_STATE.sectionData,
});

const getSectionSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  sectionData: action.payload.sectionData,
});

const getSectionFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  sectionData: INITIAL_STATE.sectionData,
});

// Filter Sections
const filterSectionsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  sectionsList: INITIAL_STATE.sectionsList,
});

const filterSectionsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  sectionsList: action.payload.sectionsList,
  totalCount: action.payload.totalCount,
});

const filterSectionsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  sectionsList: INITIAL_STATE.sectionsList,
});

// Create Section
const createSectionRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  sectionCreated: INITIAL_STATE.sectionCreated,
});

const createSectionSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  sectionCreated: action.payload.sectionCreated,
});

const createSectionFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  sectionCreated: INITIAL_STATE.sectionCreated,
});

// Create Sections
const createSectionsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const createSectionsSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const createSectionsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Update Section
const updateSectionRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateSectionSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  sectionData: action.payload.sectionData,
});

const updateSectionFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Stop
const deleteSectionRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteSectionSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteSectionFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

const reducer = createReducer(INITIAL_STATE, {
  [SectionsTypes.LIST_SECTIONS_REQUEST]: listSectionsRequest,
  [SectionsTypes.LIST_SECTIONS_SUCCESS]: listSectionsSuccess,
  [SectionsTypes.LIST_SECTIONS_FAILURE]: listSectionsFailure,

  [SectionsTypes.GET_SECTION_REQUEST]: getSectionRequest,
  [SectionsTypes.GET_SECTION_SUCCESS]: getSectionSuccess,
  [SectionsTypes.GET_SECTION_FAILURE]: getSectionFailure,

  [SectionsTypes.FILTER_SECTIONS_REQUEST]: filterSectionsRequest,
  [SectionsTypes.FILTER_SECTIONS_SUCCESS]: filterSectionsSuccess,
  [SectionsTypes.FILTER_SECTIONS_FAILURE]: filterSectionsFailure,

  [SectionsTypes.CREATE_SECTION_REQUEST]: createSectionRequest,
  [SectionsTypes.CREATE_SECTION_SUCCESS]: createSectionSuccess,
  [SectionsTypes.CREATE_SECTION_FAILURE]: createSectionFailure,

  [SectionsTypes.CREATE_SECTIONS_REQUEST]: createSectionsRequest,
  [SectionsTypes.CREATE_SECTIONS_SUCCESS]: createSectionsSuccess,
  [SectionsTypes.CREATE_SECTIONS_FAILURE]: createSectionsFailure,

  [SectionsTypes.UPDATE_SECTION_REQUEST]: updateSectionRequest,
  [SectionsTypes.UPDATE_SECTION_SUCCESS]: updateSectionSuccess,
  [SectionsTypes.UPDATE_SECTION_FAILURE]: updateSectionFailure,

  [SectionsTypes.DELETE_SECTION_REQUEST]: deleteSectionRequest,
  [SectionsTypes.DELETE_SECTION_SUCCESS]: deleteSectionSuccess,
  [SectionsTypes.DELETE_SECTION_FAILURE]: deleteSectionFailure,
});

export default reducer;
